import React from 'react';
const ToastContext = React.createContext<any>({ toast: null, setToast: () => {} });
export default ToastContext;
